<template>
    <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
        <div class="contacts-9 py-lg-5 py-md-4">
            <div class="container">
                <div class="header-sec text-center mb-5">
                    <br />
                    <h1 class="title-w3l">
                        Add Product
                    </h1>
                    <h6 class="title-subhny mb-2">What problems do you solve?</h6>
                </div>
                <div class="contactct-fm map-content-9">
                    <NuxtLink to="/dashboard"><button class="btn btn-outline-secondary">Back</button></NuxtLink>
                    <br /><br />
                    <p><b>ForumLeadsFinder</b> will search forums and social media for conversations where people are complaining about problems your product or business can remedy.</p>
                    <br />
                    <form class="pt-lg-4" onsubmit="return false;">
                        <label for="name">Name of product</label>
                        <input type="text" class="form-control" id="name" v-model="name" />
                        <br />
                        <label for="link">Link to product</label>
                        <input type="url" class="form-control" id="link" v-model="link" />
                        <br />
                        <label for="problems">Write a little about your product and all the problems it solves </label>
                        <box-icon class="float-end clickable" @click="showExample" color="var(--font-color)"
                            name='info-circle' animation='tada'></box-icon>
                        <br />
                        <textarea id="problems" type="text" class="form-control" v-model="problems"></textarea>
                        <br />
<!--                        <div>Keywords to target</div>-->
<!--                        <br />-->
<!--                        <div v-for="(keyword, index) in keywords" :key="index">-->
<!--                            <div class="input-group">-->
<!--                                <input type="text" class="form-control" v-model="keywords[index]">-->
<!--                                <button class="btn btn-danger" type="button" :id="`deleteKeyword${index}`"-->
<!--                                    v-on:click="deleteKeyword(index)">Delete</button>-->
<!--                            </div>-->
<!--                            <br />-->
<!--                        </div>-->
<!--                        <button class="btn btn-outline-primary" type="button" v-on:click="addKeyword">Add Keyword</button>-->
<!--                        <div class="align-text-right">Expect to spend about {{ keywords.length * 1666.667 }} tokens daily.</div>-->
<!--                        <br />-->
<!--                      <div class="form-check">-->
<!--                        <input class="form-check-input better-checkbox" type="checkbox" value="" id="nsfw" v-model="nsfwFlag"/>-->
<!--                        <label class="form-check-label" for="nsfw">-->
<!--                          Allow NSFW leads-->
<!--                        </label>-->
<!--                      </div>-->

                      <br />
                        <div class="text-center"><button class="btn btn-primary" type="button"
                                v-on:click="createSequence"> {{ working ? "Creating Product..." : "Create Product" }}
                            </button></div>
                    </form>
                    <br />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import Log from "../../Common/Client/Log";
import Info from "../../Common/Client/Info";
import Notification from "../../Common/Client/Notification";
import Globals from "../global";
import ClientGlobals from "../clientGlobals";

const token = useCookie("TOKEN", { maxAge: Globals.ONE_YEAR, path: "/", sameSite: "lax" });
const headers = useRequestHeaders(['cookie'])
const route = useRoute();
const keywords = ref([""]);
const problems = ref("");
const name = ref("");
const link = ref("");
const working = ref(false);
const nsfwFlag = ref(false);
const problemsTextExample = "ForumLeadsFinder is a SAAS that helps you find leads/clients by searching social media and forums for the keywords given to it, analyzes the context and meaning behind the conversations on these platforms, and alerts you to conversations where you can plug your product.";

function log(message: string, isInfo: boolean = true) {
    Log.log(message, route.path, isInfo, headers);
}

function addKeyword() {
    keywords.value.push("");
}

function showExample(){
  //@ts-ignore
  Swal.fire({
    titleText: "Info",
    html: `
            <p>For Example:</p><br>
            <p class="text-start">${problemsTextExample}</p>
            `,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: false,
    showConfirmButton: true,
    // showCancelButton: true,
    confirmButtonText: "Ok"
  })
}

function deleteKeyword(index: number) {
    keywords.value.splice(index, 1);
}

async function createSequence() {
    try {
        working.value = true;
        log("User clicked 'Create Sequence'");
        log(`Problems: ${problems.value}`);
        log(`Name: ${name.value}`);
        log(`Link: ${link.value}`);
        log(`nsfwFlag: ${nsfwFlag.value}`);
        // log(`Keywords: ${Info.prettifyIfPossible(keywords.value)}`);
        log("Send details to server");
        const sequence = { problems: problems.value, name: name.value, link: link.value, keywords: keywords.value, nsfwFlag: nsfwFlag.value };
        const response = await $fetch.raw(`/api/sequence`, {
            method: "POST",
            body: sequence,
            headers,
            ignoreResponseError: true
        });
        if (await ClientGlobals.logOutIfUnAuthorized(response, token))
            return;
        const code: number = response.status;
        log(`code: ${code}`);
        if (code != 200) {
          Notification.error("Error", "Could not create the product");
            log("If invalid, show errors");
            const errors: any = await response._data;
            for (let i = 0; i < errors.length; i++)
                Notification.error("Error occurred", errors[i]);
            return;
        }
        log("If successful, go to dashboard");
        Notification.success("Success", "Product Successfully Added");
        await navigateTo("/dashboard");
    }
    catch (ex) {
        log("Error occurred while creating sequence", false);
        log(Info.prettifyIfPossible(ex), false);
        Log.reportError(headers);
    }
    finally {
        working.value = false;
    }
}

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Add a new product`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Enter details about a new product you would like ForumLeadsFinder to find leads for`
    }
  ]
});
</script>



<style scoped></style>
